import { PropsWithChildren } from 'react';

import { Flex } from '../../summary/components/Flex.js';
import { Table } from '../../summary/components/Table.js';

export const SummaryTable = ({ children }: PropsWithChildren) => {
  return (
    <Flex
      backgroundColor="surface2"
      width="100%"
      borderRadius=".75rem"
      marginTop="1rem"
      padding="1rem"
      borderWidth="1px"
      borderStyle="solid"
      borderColor="strokeDefault"
      flexShrink={0}
      wrap={false}
    >
      <Table backgroundColor="surface1">{children}</Table>
    </Flex>
  );
};
